import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import styled from 'styled-components'
import { push } from 'connected-react-router'
import colors from '../configuration/colors'
import { Display } from '../components/styled/typography/typography'
import { H4 } from '../components/styled/typography/typography'
import FourOhFourSvg from '../static/images/404/404.svg'
import LogoSvg from '../static/images/branding/quest_logo.svg'

const NotFoundWrapper = styled.div`
  background: ${colors.smoke};
  text-align: center;

  .not-found-bg {
    position: absolute;
    top: 0;
    left: 0;
    height: 260px;
    width: 100%;
    background-color: rgba(36, 54, 70, 0.95);
    z-index: 0;
  }

  .not-found {
    position: absolute;
    top: 200px;
    left: 50%;
    height: 230px;
    width: 600px;
    padding: 60px 0;
    background-color: ${colors.white};
    border-radius: 8px;
    box-shadow: 0 1px 9px 0 rgba(0, 0, 0, 0.08);
    transform: translateX(-50%);
    z-index: 1;
  }

  h2 {
    color: ${colors.black};
  }

  .oops {
    margin: 16px 0 26px 0;
    font-size: 22px;
  }

  .telescope {
    position: absolute;
    top: 36px;
    left: 50%;
    height: 203px;
    width: 280px;
    background: no-repeat url(${FourOhFourSvg});
    background-size: contain;
    transform: translateX(-50%);
    z-index: 2;
  }

  &.not-authenticated {
    .not-found {
      position: absolute;
      top: 50%;
      left: 50%;
      height: 470px;
      width: 456px;
      padding: 0;
      background-color: rgba(255, 255, 255, 1);
      border-radius: 20px;
      box-shadow: 3px 4px 80px 0 rgba(0, 0, 0, 0.08);
      transform: translate(-50%, -50%);
      z-index: 1;
    }

    .not-found-inner {
      position: relative;
      border-radius: 20px;
    }

    .top {
      height: 215px;
      background: rgba(36, 54, 70, 1);
      border-top-left-radius: 20px;
      border-top-right-radius: 20px;
    }

    .bottom {
      background: ${colors.white};
    }

    .logo {
      position: absolute;
      top: -50px;
      left: 50%;
      width: 100px;
      height: 100px;
      background: no-repeat url(${LogoSvg});
      background-size: contain;
      transform: translateX(-50%);
    }

    .telescope {
      position: absolute;
      top: 70px;
      left: 50%;
      height: 165px;
      width: 238px;
      background: no-repeat url(${FourOhFourSvg});
      background-size: contain;
      transform: translateX(-50%);
      z-index: 2;
    }

    .black-hole {
      position: absolute;
      top: 108px;
      right: 100px;
      height: 30px;
      width: 30px;
      background: rgba(36, 54, 70, 1);
      z-index: 3;
    }

    .oops {
      margin: 68px 0 20px 0;
      font-size: 18px;
      font-weight: 500;
    }

    .h4 {
      margin-bottom: 28px;
      font-size: 16px;
    }
  }
`

const H4NotAuthenticated = styled(H4)`
  margin-bottom: 28px;
  font-size: 16px;
`

export const NotFound = ({ dispatch, isAuthenticated, isMentor, user }) => {
  const navigate = () => {
    const url = isAuthenticated
      ? isMentor
        ? '/mystudents'
        : `/user/${user.id}/dashboard`
      : '/login'
    dispatch(push(url))
  }

  return isAuthenticated ? (
    <NotFoundWrapper>
      <div className='not-found-bg'/>
      <div className='telescope'/>
      <div className="not-found">
        <Display className="oops">Oops! We can't find that page.</Display>

        <div className="quest-btn btn-a uncap" onClick={navigate}>
          Go to {isMentor ? 'My Students' : 'My Courses'}
        </div>
      </div>
    </NotFoundWrapper>
  ) : (
    <NotFoundWrapper className="not-authenticated">
      <div className="not-found">
        <div className="not-found-inner">
          <div className="top">
            <div className='logo'/>
            <div className='telescope'/>
            <div className='black-hole'/>
          </div>
          <div className="bottom">
            <Display className="oops">
              The page you're looking for isn't available.
            </Display>
            <H4NotAuthenticated>
              Logging in to Quest! might help.
            </H4NotAuthenticated>
            <div className="quest-btn btn-a uncap" onClick={navigate}>
              Sign in to Quest!
            </div>
          </div>
        </div>
      </div>
    </NotFoundWrapper>
  )
}

NotFound.propTypes = {
  dispatch: PropTypes.func,
  isAuthenticated: PropTypes.bool,
  isMentor: PropTypes.bool,
  user: PropTypes.object
}

export const mapStateToProps = state => ({
  isAuthenticated:
    sessionStorage.getItem('oef-token') || state.auth.isAuthenticated,
  isMentor: state.auth.isMentor,
  user: state.auth.user
})

export default connect(mapStateToProps)(NotFound)
